/* global google */
export default {
  init: function () {

    function handleLocationError(browserHasGeolocation) {
      let message = "There was an error. We cannot find your location automatically.";

      if (browserHasGeolocation) {
        message = "Your browser doesn't support or it's not allowing the use of Geolocation.";
      }

      $('.link-wrapper i').removeClass('fa-circle-notch fa-spin');
      $('.link-wrapper i').addClass('fa-map-marker');

      if ($('.alert').length > 0) {
        $('.alert').text(message);
      } else {
        $('.form-wrapper').prepend('<div class="alert alert-warning" role="alert">' + message + '</div>');
      }

    }

    $('#find-my-zip').click(function (e) {
      e.preventDefault();

      $('.link-wrapper i').removeClass('fa-map-marker');
      $('.link-wrapper i').addClass('fa-circle-notch fa-spin');

      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(function (position) {

          let geocoder = new google.maps.Geocoder;
          let latlng = {lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude)};

          geocoder.geocode({'location': latlng}, function (results, status) {
            if (status === 'OK') {

              if (results[0]) {
                $.each(results, function (i, el) {
                  if (el.types[0] == "postal_code") {
                    let postal = el['address_components'][0]['long_name'];
                    if (postal.length > 3) {
                      $('#zip-input').val(postal);

                      $('.link-wrapper i').removeClass('fa-circle-notch fa-spin');
                      $('.link-wrapper i').addClass('fa-map-marker');
                      return false;
                    }
                  }
                });

              } else {
                handleLocationError(true);
              }
            } else {
              handleLocationError(true);
            }
          });

        }, function () {
          handleLocationError(true);
        });

      } else {
        // Browser doesn't support Geolocation
        handleLocationError(false);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/price-by-location.js